import { InformativeBannerSection } from 'app/src/features/UserInfo/components/InformativeBannerSection'
import { SimpleTextSection } from 'app/src/features/UserInfo/components/SimpleTextSection'
import { UserDataSection } from 'app/src/features/UserInfo/components/UserDataSection'
import { UserFamilyMembersSection } from 'app/src/features/UserInfo/components/UserFamilyMembersSection'
import { membershipApi, pageconfigurationsApi } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { getFromSessionStorage } from 'app/src/shared/helpers/funcutils'
import { useWebAppContext } from 'app/src/shared/hooks'
import { ProgressSpinner } from 'primereact/progressspinner'
import type { ReactElement } from 'react'

export function ComponentRenderer(sections?: pageconfigurationsApi.SectionItem[]): ReactElement {
  const context = useWebAppContext()
  const campaignStorage = getFromSessionStorage('selectedCampaign') ?? '{}'
  const membershipId = JSON.parse(campaignStorage).membershipId
  const membershipResponse = membershipApi.useMembershipGet<membershipApi.MembershipExtended>(
    {
      pathParams: { membershipId: membershipId },
      queryParams: { includeFamilyMembers: true },
    },
    { enabled: !!membershipId },
  )
  if (membershipResponse.isLoading) {
    return (
      <div className='flex w-[100%] items-center justify-center'>
        <ProgressSpinner data-testid='loading-element' className='mt-10 flex justify-center' />
      </div>
    )
  }
  return (
    <>
      {sections &&
        sections?.map((section) => {
          switch (section.sectionName) {
            case 'InformativeBannerSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <InformativeBannerSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'SimpleTextSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <SimpleTextSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'UserDataSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => (
                    <UserDataSection
                      {...props}
                      userInfo={membershipResponse.data?.membershipInfo}
                      acceptIban={membershipResponse.data?.welfareCampaign.configuration.refundSettleMode !== 'payslip'}
                      membershipId={membershipId}
                    />
                  )}
                  sectionItem={section}
                />
              )
            case 'UserFamilyMembersSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <UserFamilyMembersSection {...props} userInfo={membershipResponse.data} />}
                  sectionItem={section}
                />
              )
            default:
              if (section?.renderingMode !== 'native') {
                return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
              } else {
                context.logger?.warn('Unknown Native Section', { section: section.sectionName })
                return <></>
              }
          }
        })}
    </>
  )
}
